const MessageType = {
    Text: 'Text',
    File: 'File',
    Reservation: 'Reservation'
};

export {MessageType};
